import React from 'react';
import { Drawer } from 'antd';
import MedicineFormMobile from './MedicineFormMobile';
import { Medicine } from '../../services/medicineService';

interface MedicineMobileModalProps {
  visible: boolean;
  medicine?: Medicine;
  onCancel: () => void;
  onSuccess: () => void;
}

const MedicineMobileModal: React.FC<MedicineMobileModalProps> = ({
  visible,
  medicine,
  onCancel,
  onSuccess,
}) => {
  const isEditing = !!medicine;
  const title = isEditing ? 'Cập nhật sản phẩm' : 'Thêm sản phẩm mới';

  return (
    <Drawer
      title={title}
      open={visible}
      onClose={onCancel}
      placement="bottom"
      height="90vh"
      bodyStyle={{ padding: 16, background: '#f5f6fa' }}
      destroyOnClose
      className="medicine-mobile-modal"
      footer={null}
    >
      <MedicineFormMobile
        medicine={medicine}
        onSuccess={() => {
          onSuccess();
          onCancel();
        }}
        onCancel={onCancel}
      />
    </Drawer>
  );
};

export default MedicineMobileModal;
